import React from 'react'
import { Link } from 'react-router-dom'
import withRouter from '../../components/Common/withRouter'

function MobileNavbarIcon(props) {
  const currentPath = props.router?.location?.pathname || window.location.pathname

  let logUser = {}
  try {
    const userStr = localStorage.getItem("user")
    if (userStr) {
      logUser = JSON.parse(userStr)
    }
  } catch (error) {
    console.error("Error parsing user from localStorage:", error)
  }
  const userRole = logUser.role || ""

  // Define navigation items based on role
  const getNavItems = () => {
    const baseItems = [
      {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
      }
    ]

    switch (userRole) {
      case "ADMIN":
      case "SUBADMIN":
        return [
          ...baseItems,
          {
            label: "Hotels",
            icon: "mdi mdi-office-building-outline",
            url: "/hotels",
          },
          {
            label: "Request",
            icon: "mdi mdi-calendar-outline",
            url: "/pendinghotels",
          },
          {
            label: "Profile",
            icon: "mdi mdi-account-outline",
            url: "/userprofile",
          },
        ]

      case "HOTEL_ADMIN":
        return [
          ...baseItems,
          {
            label: "Reservations",
            icon: "mdi mdi-calendar-check-outline",
            url: "/reservations",
          },
          {
            label: "Guests",
            icon: "mdi mdi-account-outline",
            url: "/guest",
          },
          {
            label: "Profile",
            icon: "mdi mdi-account-circle-outline",
            url: "/userprofile",
          },
        ]

      case "RECEPTIONIST":
        return [
          ...baseItems,
          {
            label: "Reservations",
            icon: "mdi mdi-calendar-check-outline",
            url: "/reservations",
          },
          {
            label: "Rooms",
            icon: "mdi mdi-bed-outline",
            url: "/rooms",
          },
          {
            label: "Profile",
            icon: "mdi mdi-account-outline",
            url: "/userprofile",
          },
        ]

      case "SPA":
        return [
          ...baseItems,
          {
            label: "Spa",
            icon: "mdi mdi-spa-outline",
            url: "/spa",
          },
          {
            label: "Guests",
            icon: "mdi mdi-account-outline",
            url: "/guest",
          },
          {
            label: "Profile",
            icon: "mdi mdi-account-outline",
            url: "/userprofile",
          },
        ]

      case "FOOD AND BEVERAGE":
        return [
          ...baseItems,
          {
            label: "Menu",
            icon: "mdi mdi-silverware-fork-knife",
            url: "/Customer-menu",
          },
          {
            label: "Guests",
            icon: "mdi mdi-account-outline",
            url: "/guest",
          },
          {
            label: "Profile",
            icon: "mdi mdi-account-outline",
            url: "/userprofile",
          },
        ]

      case "MANAGER":
        return [
          ...baseItems,
          {
            label: "Reservations",
            icon: "mdi mdi-calendar-check-outline",
            url: "/reservations",
          },
          {
            label: "Guests",
            icon: "mdi mdi-account-outline",
            url: "/guest",
          },
          {
            label: "Profile",
            icon: "mdi mdi-account-outline",
            url: "/userprofile",
          },
        ]

      default:
        return [
          ...baseItems,
          {
            label: "Profile",
            icon: "mdi mdi-account-outline",
            url: "/userprofile",
          },
        ]
    }
  }

  const navItems = getNavItems()

  // Check if a route is active
  const isActive = (url) => {
    if (url === "/dashboard") {
      return currentPath === "/dashboard" || currentPath === "/"
    }
    return currentPath.startsWith(url)
  }

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#1b2c3f",
        padding: "12px 0",
        borderRadius: "20px 20px 0 0",
        zIndex: 1000,
        boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          maxWidth: "100%",
          margin: "0 auto",
        }}
      >
        {navItems.map((item, index) => {
          const active = isActive(item.url)
          return (
            <Link
              key={index}
              to={item.url}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
                color: "#fff",
                flex: 1,
                padding: "8px 4px",
                position: "relative",
              }}
            >
              <div
                style={{
                  width: active ? "48px" : "40px",
                  height: active ? "48px" : "40px",
                  borderRadius: "50%",
                  backgroundColor: active ? "#fff" : "transparent",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.3s ease",
                  marginBottom: "4px",
                }}
              >
                <i
                  className={item.icon}
                  style={{
                    fontSize: "20px",
                    color: active ? "#1b2c3f" : "#fff",
                    transition: "all 0.3s ease",
                  }}
                ></i>
              </div>
              <span
                style={{
                  fontSize: "10px",
                  color: "#fff",
                  fontWeight: active ? "600" : "400",
                  textAlign: "center",
                }}
              >
                {item.label}
              </span>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default withRouter(MobileNavbarIcon)
